export const Faqs = [
    {
        question: "What is a one-to-one online class?",
        answer: "A one-to-one class is a private, personalized session between a student and a tutor. The tutor tailors the lesson entirely to your child’s pace, learning style, and academic goals—offering more focus and flexibility than group classes."
    },
    {
        question: "How do I book a free demo class?",
        answer: "Simply click the “Book Free Demo” button on the homepage. You’ll be guided through a quick 2-minute form to select your subject, preferred time, and tutor. No payment or commitment required."
    },
    {
        question: "Are live online classes effective?",
        answer: "Yes—extremely. 95% of World O’ Tutors students see grade improvements within the first 3 months. Live interaction, real-time feedback, and personalized lesson plans drive faster learning outcomes."
    },
    {
        question: "Can I choose a tutor based on my location or time zone?",
        answer: "Yes. We offer certified tutors from the USA, UK, Canada, Australia, and more. You can filter by location, subject expertise, availability, and even language preference to find the right fit for your schedule."
    },
    {
        question: "How does virtual learning compare to in-person tutoring?",
        answer: "Virtual tutoring is just as effective—often more so. It saves travel time, offers greater scheduling flexibility, and gives you access to global expert tutors. Our virtual whiteboards and interactive tools ensure a dynamic and engaging learning experience."
    },
    {
        question: "Is the platform safe for kids to use?",
        answer: "Absolutely. Safety is our top priority. All tutors are vetted through a multi-stage background check, and all sessions are monitored or recorded (with parental permission) for accountability. Parents also have full visibility and control over bookings."
    },
    {
        question: "What subjects and age groups do you support?",
        answer: "We offer live online tutoring across core academic subjects (Math, Science, English, Coding, Languages, etc.) as well as enrichment courses (Chess, Music, Public Speaking, etc.) for learners aged 4–18+. College and adult learning support is also available."
    },
    {
        question: "What devices do I need to attend a class?",
        answer: "All you need is a smartphone, tablet, or computer with internet access. No software download is required—our platform works directly in your browser. Headphones and a webcam are recommended for the best experience."
    },
    {
        question: "Do your tutors follow my local school curriculum?",
        answer: "Yes. Our tutors are trained to align with international curricula such as CBSE, ICSE, IGCSE, IB, GCSE, Ontario, and Common Core. You can select a tutor who specializes in your country’s syllabus for seamless school support."
    },
    {
        question: "Can I change my tutor if I’m not satisfied?",
        answer: "Of course. If you feel a tutor isn’t the right fit, you can switch to another tutor at no extra cost. We want every learner to feel confident, comfortable, and supported."
    },
    {
        question: "How much do classes cost after the free demo?",
        answer: "Our pricing is flexible based on your country, class frequency, and subject. Packages start at competitive rates, and we offer bundle discounts. Contact our support team or view plans during booking for exact pricing."
    },
    {
        question: "How do I track my child’s progress?",
        answer: "After each session, you’ll receive a class report with learning outcomes, areas for improvement, and tutor feedback. You can also log in to the parent dashboard to view attendance, goals, and upcoming sessions."
    },
    {
        question: "Do tutors speak multiple languages?",
        answer: "Many of our tutors are multilingual. If your child is more comfortable learning in Hindi, Spanish, French, or other supported languages, we can match you with a tutor who speaks that language fluently."
    },
    {
        question: "What if I need technical help or support?",
        answer: "Our customer support team is available via chat, phone, or email 24/7. Whether it’s a scheduling issue, login trouble, or tutor request—we’re here to help"
    }
]